export const UPDATE_PUBLISH_DATA = "UPDATE_PUBLISH_DATA";
export const RESET_STORE = "RESET_PUBLISH_NINJA_STORE";
